// extracted by mini-css-extract-plugin
module.exports = {"boxes":"OurSuccessGuarantee-module__boxes___24nK5","Box":"OurSuccessGuarantee-module__Box___2mRJL","header":"OurSuccessGuarantee-module__header___1OO7D"};